const LOGIN_TOAST_BY_AUTH_ERROR: Record<string, string> = {
    account_blocked: 'Учётная запись заблокирована. Обратитесь к администратору.',
    organization_blocked: 'Организация отключена. Обратитесь к администратору.',
};

export type LoginErrorPresentation = {
    inline: string | null;
    toast: string | null;
};

/** На логине любой 401 мапится в «Неверный логин или пароль»; блокировку показываем тостом. */
export function resolveLoginErrorPresentation(
    fallback: string | null,
    error: { response?: { data?: { auth_error?: string; message?: string } } } | null | undefined
): LoginErrorPresentation {
    const data = error?.response?.data;
    const toastFallback = data?.auth_error ? LOGIN_TOAST_BY_AUTH_ERROR[data.auth_error] : undefined;
    if (toastFallback) {
        return { inline: null, toast: data?.message || toastFallback };
    }
    return { inline: fallback, toast: null };
}
